<template>
  <div :class="{ 'is-invalid': showValidationError }">
    <label v-if="label" :class="labelClasses" :for="editorId">
      <required v-if="required" />
      {{ label }}
    </label>

    <editor-with-content-blocks v-if="anyContentBlocks" ref="trix" :src-content="value" :input-name="inputName"
                                :content-blocks="contentBlocks" :content-blocks-base-path="contentBlocksBasePath"
                                :show-html-mode="showHtmlMode" :show-attach-files="showAttachFiles" :show-code-button="showCodeButton"
                                @input="updateText" @blur="$emit('blur')" @focus="$emit('focus')" @change-to-html-mode="changeToHtmlMode" />

    <editor v-else ref="trix" :src-content="value" :input-name="inputName" :show-html-mode="showHtmlMode"
            :show-attach-files="showAttachFiles" :allowed-attachment-types="allowedAttachmentContentTypes"
            :show-code-button="showCodeButton" :show-heading-button="showHeadingButton" :validate-href="validateHref"
            @input="updateText" @blur="$emit('blur')" @focus="$emit('focus')" @change-to-html-mode="changeToHtmlMode" />

    <p v-if="helpText" class="form-text text-muted" v-html="helpText" />

    <validation-errors v-if="showValidationError" :errors="validationErrors" />
  </div>
</template>

<script>
import Editor from './trix/editor'
import EditorWithContentBlocks from './trix/editor-with-content-blocks'
import kebabCase from 'lodash/kebabCase'
import { nextTick } from 'vue'
import Required from '@/components/required'
import ValidationErrors from './validation-errors'

export default {
  components: { Editor, EditorWithContentBlocks, Required, ValidationErrors },

  props: {
    allowedAttachmentContentTypes: {
      type: Array,
      required: false
    },
    contentBlocks: {
      type: Array,
      required: false,
      default: () => []
    },
    contentBlocksBasePath: {
      type: String,
      required: false
    },
    helpText: {
      type: String,
      required: false
    },
    inputName: {
      type: String,
      required: false,
      default: 'content'
    },
    label: {
      type: String,
      required: false
    },
    labelCssClass: {
      type: String,
      required: false,
      default: ''
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    showAttachFiles: {
      type: Boolean,
      required: false,
      default: true
    },
    showCodeButton: {
      type: Boolean,
      required: false,
      default: false
    },
    showHeadingButton: {
      type: Boolean,
      required: false,
      default: true
    },
    showHtmlMode: {
      type: Boolean,
      required: false,
      default: true
    },
    value: {
      type: String,
      required: false
    },
    validationErrors: {
      type: Array,
      required: false
    },

    validateHref: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  emits: ['blur', 'change-to-html-mode', 'focus', 'input'],

  computed: {
    anyContentBlocks() {
      return this.contentBlocks.length > 0
    },

    editorId() {
      return kebabCase(this.inputName)
    },

    labelClasses() {
      return [this.labelCssClass, 'string', { 'required': this.required }]
    },

    showValidationError() {
      return this.validationErrors && this.validationErrors.length > 0
    }
  },

  methods: {
    updateText(newValue) {
      // Wait until the next tick, to avoid weirdness if emitting the new value
      // causes our 'value' prop to be updated.
      nextTick(() => {
        this.$emit('input', newValue)
      })
    },

    changeToHtmlMode() {
      this.$emit('change-to-html-mode')
    },

    focus() {
      this.$refs.trix.focus()
    }
  }
}
</script>
